import type {
  AddressProviderStatusCombo,
  AddressSpending,
  AnalyticsParams,
  AnalyticsSummary,
  ProviderSpending,
  SpendingPeriod,
} from "../../types/analytics";
import type { ApiRequestFn, RecordStringNumber } from "../../types/api";
import { buildQueryString } from "../../utils/query";

const createAnalyticsApi = (request: ApiRequestFn) => ({
  spending: (params?: AnalyticsParams) => {
    const qs = buildQueryString(params);
    return request<SpendingPeriod[]>(`/me/analytics/spending${qs ? `?${qs}` : ""}`);
  },

  byProvider: (from?: string, to?: string) => {
    const qs = buildQueryString({ from, to });
    return request<ProviderSpending[]>(`/me/analytics/by-provider${qs ? `?${qs}` : ""}`);
  },

  byAddress: (from?: string, to?: string) => {
    const qs = buildQueryString({ from, to });
    return request<AddressSpending[]>(`/me/analytics/by-address${qs ? `?${qs}` : ""}`);
  },

  statusDistribution: () => request<RecordStringNumber>("/me/analytics/status-distribution"),

  summary: () => request<AnalyticsSummary>("/me/analytics/summary"),

  byAddressProviderStatus: (from?: string, to?: string) => {
    const qs = buildQueryString({ from, to });
    return request<AddressProviderStatusCombo[]>(`/me/analytics/by-address-provider-status${qs ? `?${qs}` : ""}`);
  },
});

export { createAnalyticsApi };
